import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';
import ScrollReveal from './ScrollReveal';

const ContactSection = () => {
  const contactInfo = [
    {
      icon: <FaWhatsapp className="text-3xl text-secondary" />,
      title: 'כתבו בווטסאפ',
      value: 'שלחו הודעה',
      href: 'https://wa.me/972523608585?text=אני%20רוצה%20לקחת%20את%20העסק%20שלי%20לשלב%20הבא%20💪🏼%0Aאשמח%20לשמוע%20פרטים'
    },
    {
      icon: <FaPhone className="text-3xl text-secondary" />,
      title: 'התקשרו אלינו',
      value: '052-360-8585',
      href: 'tel:0523608585'
    }
  ];

  return (
    <section id="contact" className="section-padding relative mt-12 sm:mt-0">
      <div className="container mx-auto px-4 relative z-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
              איך מתחילים?
            </h2>
            <div className="accent-line bg-cta"></div>
            <p className="text-xl sm:text-2xl text-gray-300 max-w-2xl mx-auto">
              לחיצת כפתור והעסק שלך עולה שלב
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8">
              {contactInfo.map((info, index) => (
                <motion.a
                  key={index}
                  href={info.href}
                  target={info.title === 'כתבו בווטסאפ' ? '_blank' : undefined}
                  rel={info.title === 'כתבו בווטסאפ' ? 'noopener noreferrer' : undefined}
                  whileHover={{ scale: 1.05, y: -5 }}
                  whileTap={{ scale: 0.95 }}
                  className="text-center p-8 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-all duration-300 hover:shadow-xl"
                >
                  <div className="w-20 h-20 bg-cta/20 rounded-full flex items-center justify-center mx-auto mb-6">
                    {info.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-3">
                    {info.title}
                  </h3>
                  <p className="text-lg text-gray-300 font-medium">
                    {info.value}
                  </p>
                </motion.a>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default ContactSection; 